import React from 'react';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';
import { foundryContent } from '../rich-content/foundry-complete-content';

const FoundryDetailPage = () => {
  return <AutomaticPageBuilder content={foundryContent} />;
};

export default FoundryDetailPage;